// TODO: This is wrong, shouldn't pass domain object into service
import { SplitPaymentDto } from './split-payment-dto';

export class OrderPaymentOptionsDto {
  splitPayment: boolean;
  splitPayments: Array<SplitPaymentDto> = [];
  paymentByWireTransferOnly: boolean;
}
